<template>
    <div id="post-nav" class="post-nav">
        <ul class="post-nav__list">
            <li class="post-nav__item line-clamp" v-for="post in sortedPosts" :key="post.id">
                <router-link :to="`/blog/post/${post.slug}`">
                    {{ post.title }}
                </router-link>
            </li>
            <li>
                <router-link :to="`/blog`">
                    <img src="@/assets/img/blog/right-arrow-blog.svg" alt="Right Arrow" class="post-nav__arrow" />
                </router-link>
            </li>
        </ul>
    </div>
</template>
<style scoped>
.post-nav {
    margin: 4rem 0 1rem 0;
}

.post-nav__arrow {
    width: 4.5rem;
    height: 1.5rem;
    margin-left: 1rem;
    transition: all 0.2s ease-in-out;
}

.post-nav__arrow:hover {
    scale: 1.05;
}

.post-nav__item,
.post-nav__list {
    display: flex;
    justify-content: start;
    align-items: center;
    margin: 0.8rem 0 0.6rem 0;
    list-style: none;
    font-weight: 600;
    line-height: 1.2;
    font-size: 13px;
}

.line-clamp {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.post-nav__list {
    gap: 10rem;
}

.post-nav__item:hover {
    scale: 1.01;
    transition: all 0.2s ease-in-out;
}

@media only screen and (max-width: 768px) {
    .post-nav__arrow {
        width: 3rem;
        height: 1rem;
    }

    .post-nav {
        margin: 2rem 0 1rem 0;
        padding: 0 3rem;
    }

    .post-nav__list {
        gap: 6rem;
    }

    .post-nav__item:not(:first-child) {
        display: none;
    }
}
</style>
<script setup>
import { getBlogCollection } from '@/assets/markdowns/blog/BlogCollection.js';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const route = useRoute();

const { locale } = useI18n();
const sortedPosts = computed(() => {
    const posts = getBlogCollection(locale.value) || [];
    if (!Array.isArray(posts)) {
        console.error('Posts is not an array');
        return [];
    }
    return posts.filter(post => post.slug !== route.params.id).sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, 3);
});
</script>
